import {Grid, HorizontalList} from 'focus-manager/web';
import * as React from 'react';

import {shortcutKeys, toolbarKeys} from '../Constants/keysets';
import KeysetType from '../Constants/KeysetType';
import ReservedValue from '../Constants/ReservedValue';
import KeysetState from '../Models/KeysetState';

import Key from './Key';

interface IKeyboardProps {
    onKeySelect: (keyValue: string) => void;
}

const Keyboard: React.FC<IKeyboardProps> = ({onKeySelect}) => {
    const [keysetState, setKeysetState] = React.useState(new KeysetState(KeysetType.ALPHANUMERIC));

    const [isUpperCased, setIsUppercased] = React.useState(false);

    const handleKeySelect = React.useCallback(
        (keyValue: string) => {
            switch (keyValue) {
                case ReservedValue.TOGGLE_KEY_SET:
                    setKeysetState(({altType}) => new KeysetState(altType));

                    break;
                case ReservedValue.SHIFT:
                    setIsUppercased(prevIsUpperCased => !prevIsUpperCased);

                    break;
                default:
                    onKeySelect(keyValue);
            }
        },
        [onKeySelect]
    );

    return (
        <>
            <HorizontalList className="key-wrapper" loop focusableIndex={0}>
                {toolbarKeys.map(key => (
                    <Key
                        {...key}
                        key={key.key}
                        isSpecialChars={keysetState.isSpecialChars}
                        disableFocus={key.value === ReservedValue.SHIFT && keysetState.isShiftDisabled}
                        onSelect={handleKeySelect}
                    />
                ))}
            </HorizontalList>
            <Grid focusableId={'KEYBOARD'} className="key-wrapper" columns={10} loop focusableIndex={1}>
                {keysetState.keyset.map(key => (
                    <Key {...key} key={key.key} isUpperCased={isUpperCased} onSelect={handleKeySelect} />
                ))}
            </Grid>
            {keysetState.isAlphanumeric && (
                <HorizontalList className="key-wrapper" loop focusableIndex={2}>
                    {shortcutKeys.map(key => (
                        <Key {...key} key={key.key} onSelect={handleKeySelect} />
                    ))}
                </HorizontalList>
            )}
        </>
    );
};

export default Keyboard;
